module.exports = __webpack_public_path__ + "img/usa-tuberculosis-male.8b1bba49.png";